import { Outlet } from "react-router-dom"

export default function AppRouteContainer() {
    return (
        <>
            <section>
                {/* Pages */}
                <section>
                    <Outlet />
                </section>
            </section>
        </>
    )
}
